const paymentMethodOptions: { [key: string]: string } = {
  bank: 'Bank Account',
  'e-transfer': 'Interac e-Transfer',
  creditCard: 'Credit Card',
};

export default paymentMethodOptions;
